import * as React from 'react';
import ReactTooltip from 'react-tooltip';
import './DownloadAddInsText.css';

export interface AppProps {}

export interface AppState {
	//
}

class DownloadAddInsText extends React.Component<AppProps, AppState> {
	render() {
		return (
			<div className="download-wrapper">
				<div className="download-text"></div>
				<div className="bottom-start-workout">
					<button
						className="page-button"
						data-tip
						data-for="actionPlanTooltip"
						data-event="click">
						get action plan
					</button>
					<ReactTooltip
						id="actionPlanTooltip"
						place="bottom"
						effect="solid"
						type="light"
						wrapper="span"
						clickable={true}
						multiline={true}
						border={true}
						borderColor="#000"
						globalEventOff="click">
						To access this premium feature, join the{' '}
						<a
							href="https://www.helensword.com/writespace-signup-writersdiet"
							target="_blank"
							rel="noopener noreferrer">
							WriteSPACE
						</a>{' '}
						<br />
						today! To try free for 30 days, select the monthly
						<br />
						membership option and enter the discount code
						<br /> WRITERSDIET at checkout.
					</ReactTooltip>
				</div>
			</div>
		);
	}
}

export default DownloadAddInsText;
